import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";
import { trackEvent } from "@/lib/api";

export function CTASection() {
  const { L } = useLang();
  return (
    <section className="relative overflow-hidden bg-navy py-20 lg:py-24">
      <div className="absolute inset-0 grid-lines opacity-70" />
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-finblue/20 blur-3xl" />
      <div className="container-tight relative">
        <div className="max-w-3xl">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold tracking-tight text-white">{L.cta.title}</h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300">{L.cta.desc}</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button asChild size="lg" className="bg-finblue hover:bg-finblueDark" onClick={() => trackEvent("open_account_click", { location: "cta_section" })} data-testid="cta-open-account">
              <Link to="/broker-partners">{L.common.openAnAccount}</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-gold/50 bg-transparent text-gold hover:bg-white/5 hover:text-gold" data-testid="cta-explore-partners">
              <Link to="/broker-partners">{L.common.explorePartners}</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
